import React, { useState } from 'react'

function Projects() {
    const [filter, setFilter] = useState("All")
    const [projects, setProjects] = useState([
        {
            id: 1,
            image: 'images/Group 5.png',
            title: 'Glag Truck Schedule',
            type: 'App',
            gallery: 'assets/img/portfolio/portfolio-1.jpg',
            link: '#',
        },
        {
            id: 2,
            image: 'images/ibougeweb.png',
            title: 'Ibouge',
            type: 'Web',
            gallery: 'assets/img/portfolio/portfolio-2.jpg',
            link: 'https://www.ibouge.com/',
        },
        {
            id: 3,
            image: 'images/Group 6.png',
            title: 'Tunefly Music',
            type: 'App',
            gallery: 'assets/img/portfolio/portfolio-3.jpg',
            link: '#',
        },
        {
            id: 4,
            image: 'images/WebTune.png',
            title: 'TuneFly',
            type: 'Web',
            gallery: 'assets/img/portfolio/portfolio-5.jpg',
            link: 'https://www.tunefly.io/web/',
        },
        {
            id: 5,
            image: 'images/Group 1.png',
            title: 'MatchMap',
            type: 'App',
            gallery: 'assets/img/portfolio/portfolio-6.jpg',
            link: '#',
        },
    ]);
    const filteredProjects = projects.filter(project => filter === "All" || project.type === filter);
    return (
        <section id="projects" className="portfolio">
            <div className="container">
                <div className="section-title" data-aos="fade-up">
                    <h2>My Client Projects</h2>
                    <p>These are our expertise in Mobile Application Development and Web Application Development</p>
                </div>

                <div className="row" data-aos="fade-up" data-aos-delay="200">
                    <div className="col-lg-12 d-flex justify-content-center">
                        <ul id="portfolio-flters">
                            <li  className={filter=="All"?"filter-active":"filter-inactive"} onClick={() => setFilter("All")}>All</li>
                            <li  className={filter=="App"?"filter-active":"filter-inactive"} onClick={() => setFilter("App")} style={{marginLeft:10,marginRight:10}}>App</li>
                            <li   className={filter=="Web"?"filter-active":"filter-inactive"} onClick={() => setFilter("Web")}>Web</li>
                        </ul>
                    </div>
                </div>

                <div className="row" data-aos="fade-up" data-aos-delay="400">
                    {filteredProjects.map((project) => (
                        <div key={project.id} className={`col-lg-4 col-md-6 portfolio-item filter-${project.type.toLowerCase()}`}>
                            <div className="portfolio-wrap">
                                <img src={project.image} className="img-fluid" alt={project.title} style={{height:300,}} />
                                <div className="portfolio-info">
                                    <h4>{project.title}</h4>
                                    <p>{project.type}</p>
                                    <div className="portfolio-links">
                                        <a href={project.link} target={project.link=="#"?"":'_blank'}>
                                            <i className="bx bx-link"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default Projects